(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lp-tabs"] && !Shopify.designMode) return;
  try {
    class LPTabs extends HTMLElement {
    connectedCallback() {
      this.tablist = this.querySelector('.lp-tabs__tablist');
      this.panels = Array.from(this.querySelectorAll(':scope > .lp-tabs__panels > .lp-tabs__panel'));

      if (!this.tablist || this.panels.length === 0) return;

      this.buildTabs();
      this.selectTab(this.getInitialIndex());

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      if (window.Shopify && Shopify.designMode) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    onBlockSelect = (event) => {
      const panel = event.target.closest('.lp-tabs__panel');

      if (!panel || !this.contains(panel)) return;

      const index = this.panels.indexOf(panel);

      if (index >= 0) this.selectTab(index);
    };

    buildTabs() {
      this.tablist.innerHTML = '';

      this.panels.forEach((panel, index) => {
        const tab = document.createElement('button');
        const panelId = panel.id || `${this.id}-Panel-${index + 1}`;
        const tabId = `${panelId}-Tab`;

        panel.id = panelId;
        tab.id = tabId;
        tab.className = 'lp-tabs__tab';
        tab.type = 'button';
        tab.role = 'tab';
        tab.textContent = panel.dataset.tabTitle || `Tab ${index + 1}`;
        tab.setAttribute('aria-controls', panelId);
        tab.addEventListener('click', () => this.selectTab(index));
        tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));

        panel.role = 'tabpanel';
        panel.setAttribute('aria-labelledby', tabId);
        this.tablist.append(tab);
      });

      this.tabs = Array.from(this.tablist.querySelectorAll('.lp-tabs__tab'));
    }

    getInitialIndex() {
      const activeIndex = this.panels.findIndex((panel) => panel.dataset.tabActive === 'true');

      return activeIndex >= 0 ? activeIndex : 0;
    }

    selectTab(index, shouldFocus = false) {
      this.tabs.forEach((tab, tabIndex) => {
        const selected = tabIndex === index;

        tab.setAttribute('aria-selected', selected);
        tab.tabIndex = selected ? 0 : -1;
      });

      this.panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index;
      });

      if (shouldFocus) this.tabs[index].focus();
    }

    onTabKeydown(event, index) {
      let nextIndex = index;

      if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === index) return;

      event.preventDefault();
      this.selectTab(nextIndex, true);
    }
  }

  if (!customElements.get('lp-tabs')) {
    customElements.define('lp-tabs', LPTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
